import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import UnlockAnalyticsImage from './UnlockAnalyticsImage'

const copy = {
  heading: `Unlock advanced analytics with Profiles Sync`,
  description: `Access all of the Segment real-time profile data in your warehouse to build data models and machine learning models that can be used in campaigns to lower customer acquisition costs, increase lifetime value, and inspire engagement.`,
}

const link = {
  href: `/product/profiles-sync/`,
  text: `Explore Profiles Sync`,
}

const UnlockAnalytics: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <StyledSectionBase variant="2Col">
      <Section.Contents>
        <UnlockAnalyticsImage alt={`Illustration: ${copy.heading}`} />
      </Section.Contents>
      <StyledCopy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(link.href, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </StyledCopy>
    </StyledSectionBase>
  )
}

export default UnlockAnalytics

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`
